module.exports = __webpack_public_path__ + "assets/img/dabea307e86448afd2bc6c6ae310be76.svg";